import { Section } from "./Section";
import { Reveal } from "./Reveal";
import { INCENTIVES_MAIN, INCENTIVES_MORE, INCENTIVE_EXAMPLE } from "../../config/site";
import { BadgePercent } from "lucide-react";

export const Incentives = () => (
  <Section
    id="incentives"
    overline="Government incentives"
    title="Haryana pays you to build here"
    sub="BIDC is an approved MSME cluster in a Prime / Focus Area under the Haryana Progressive MSME & Export Promotion Policy 2026."
  >
    <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
      {INCENTIVES_MAIN.map((inc, i) => (
        <Reveal key={inc.label} delay={i * 0.07}>
          <div
            className="h-full border border-gold/40 bg-gold-pale/40 p-6 text-center transition-transform duration-200 hover:-translate-y-1"
            data-testid={`incentive-${i}`}
          >
            <p className="font-display text-4xl sm:text-5xl font-semibold text-forest">{inc.value}</p>
            <p className="mt-2 text-sm font-medium text-ink">{inc.label}</p>
            <p className="mt-1 text-xs text-[#4A4C4A]">{inc.note}</p>
          </div>
        </Reveal>
      ))}
    </div>

    <Reveal delay={0.15}>
      <div className="mt-8 flex flex-wrap gap-2.5">
        {INCENTIVES_MORE.map((m) => (
          <span
            key={m}
            className="flex items-center gap-2 border border-border bg-paper-light px-3.5 py-1.5 text-xs text-[#4A4C4A]"
          >
            <BadgePercent className="h-3.5 w-3.5 text-gold" /> {m}
          </span>
        ))}
      </div>
    </Reveal>

    <Reveal delay={0.2}>
      <div className="mt-10 border border-border bg-forest p-7 sm:p-9 grain relative" data-testid="incentive-example">
        <div className="relative">
          <h3 className="font-display text-2xl font-medium text-paper">{INCENTIVE_EXAMPLE.title}</h3>
          <div className="mt-6 space-y-3">
            {INCENTIVE_EXAMPLE.rows.map((r) => (
              <div
                key={r.item}
                className="flex items-center justify-between border-b border-paper/15 pb-3 text-sm"
              >
                <span className="text-paper/75">{r.item}</span>
                <span className="font-display text-lg font-medium text-gold">{r.amount}</span>
              </div>
            ))}
            <div className="flex items-center justify-between pt-1">
              <span className="font-medium text-paper">Total support (indicative)</span>
              <span className="font-display text-2xl font-semibold text-gold">{INCENTIVE_EXAMPLE.total}</span>
            </div>
          </div>
          <p className="mt-6 text-xs leading-relaxed text-paper/50">
            *{INCENTIVE_EXAMPLE.disclaimer} All incentives are subject to eligibility and approval
            under the Haryana Progressive MSME &amp; Export Promotion Policy 2026 and respective
            sector policies.
          </p>
        </div>
      </div>
    </Reveal>
  </Section>
);
